<div class="sg-input-container">
  <label class="sg-input-label" *ngIf="label">{{ label }}</label>
  <p class="sg-input-description" *ngIf="description">{{ description }}</p>

  <div class="sg-input-wrapper" [class.has-icon]="withIcon">
    @if (withIcon) {
      <ptl-icon class="sg-input-icon" [icon]="icon" size="xs"></ptl-icon>
    }

    <input
      *ngIf="matAutocomplete"
      #inputElement
      class="sg-input-field"
      [attr.aria-label]="label"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      [attr.maxlength]="maxLength"
      [matAutocomplete]="matAutocomplete"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />
    <input
      *ngIf="!matAutocomplete"
      #inputElement
      class="sg-input-field"
      [attr.aria-label]="label"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      [attr.maxlength]="maxLength"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    />
  </div>
</div>
